import { useField } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepickerfield.scss';

// Custom DatePicker integrated with Formik
function DatePickerField({ ...props }) {
    const [field, meta, { setValue }] = useField(props);

    return (
        <div className="datepicker-field">
            <DatePicker
                {...props}
                {...field}
                disabledKeyboardNavigation
                selected={field.value}
                onChange={(val) => setValue(val)}
                onFocus={(e) => e.target.blur()}
            />
            {meta.touched && meta.error && (
                <p className="mt-2 text-xs font-bold text-red">{meta.error}</p>
            )}
        </div>
    );
}

export default DatePickerField;
